import ChannelType from './channel-type'
import ClientInputBasicInfo from './client-input-basic-info'
import ClientInputGroupClassification from './client-input-group-classification'
import ClientInputTypeOfGroup from './client-input-type-of-group'
import ClientInputAgeProfile from './client-input-age-profile'
import ClientInputFundingArrangements from './client-input-funding-arrangements'
import ClientInputProposalType from './client-input-proposal-type'
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data'

interface Props {
    isRenewal: boolean;
}

export default function FirstStep({ isRenewal }: Props) {

    const { channelType: selectedChannelType, } = useProposalTypeData()
    
    return (
        <div className='grid grid-cols-1 gap-3.5 lg:grid-cols-3'>
            <div className='col-span-1 rounded border border-gray-200 bg-white p-3.5 md:p-4 lg:col-span-3 '>
                {isRenewal && (
                    <div className='mb-3 flex items-start gap-2.5 rounded border border-blue-200 bg-[#eef6fc] p-3'>
                        <svg xmlns="http://www.w3.org/2000/svg" className='mt-0.5 h-5 w-5 shrink-0 text-[#186cb2]' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4" />
                            <path d="M12 8h.01" />
                        </svg>
                        <div className='text-xs text-gray-700'>
                            <p className='font-semibold text-[#186cb2]'>Renewal Proposal Instructions</p>
                            <p className='mt-1 leading-relaxed'>
                                Select <strong>Renewal</strong> as the proposal type, then enter the <strong>SEC Registered Name</strong> of an existing franchise/booked group. Select the matching record from the search results, then click <strong>Populate</strong> to automatically fill in the corresponding input fields.
                            </p>
                        </div>
                    </div>
                )}
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2 text-xs'>
                    {isRenewal ? (
                        <>
                            <ClientInputProposalType isRenewal={isRenewal}/>
                            {selectedChannelType !== null && selectedChannelType.id !== 0 && (
                                <ChannelType />
                            )}
                        </>
                    ) : (
                        <>
                            <ChannelType />
                            <ClientInputProposalType/>
                        </>
                    )}
                </div>
            </div>
            <ClientInputBasicInfo />
            <div className='col-span-1 border border-gray-200 space-y-2 rounded bg-white p-3.5 md:p-4'>
                <ClientInputGroupClassification />
                {/* <hr className="h-px bg-gray-200 border-0" /> */}
                {/* <ClientInputBusinessType /> */}
            </div>
            <ClientInputTypeOfGroup />
            <div className='col-span-1 border border-gray-200 space-y-2 rounded bg-white p-3.5 md:p-4'>
                <ClientInputAgeProfile />
                <hr className="h-px bg-gray-200 border-0" />
                <ClientInputFundingArrangements />
            </div>
        </div>
    )
}
